;(function ($, window, document) {
  function onDOMContentLoaded() {
    var parent = $('div.hero-improved')
    if (parent.length === 0) {
      // our work here is done
      return
    }

    // call once immediately when ready
    doResize()

    // handle screen resizes: adjust continue-button size
    $(window).on('resize', function () {
      doResize()
    })

    function doResize() {
      var button = $('div.hero-improved .hero__content .btn')
      if (
        window.innerWidth <= 599 &&
        button.is('.btn-lg') &&
        button.not('.btn-md')
      ) {
        button.addClass('btn-md')
        button.removeClass('btn-lg')
      } else if (
        window.innerWidth > 600 &&
        button.not('.btn-lg') &&
        button.is('.btn-md')
      ) {
        button.addClass('btn-lg')
        button.removeClass('btn-md')
      }
    }
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})(jQuery, window, document)
